module.exports = __webpack_public_path__ + "img/18n.89fe917a.png";